import React, { useState, useEffect } from 'react';
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import Typography from "@mui/material/Typography";
import ArgoReviewTemplateHook from "../../common/ArgoReviewTemplateHook";
import {getQuestionnaireGraph, clearQuestionnaireGraph} from "../../../actions/questionnaireTemplateActions";
import { expanderClear } from "../../../actions/expanderActions";
import CategoryViewerExpandableHook from "../categories/CategoryViewerExpandableHook";
import ArgoDividerWithLabelHook from "../../common/ArgoDividerWithLabelHook";
import ArgoPortalPreviewHook from "../../common/ArgoPortalPreviewHook";
import statusFormatter from "../../../utilities/StatusFormatter";
import * as metadataUtils from "../../../utilities/metadata";
import * as TEMPLATE from "../../../constants/templateConstants";
import * as portalShared from "../../../portal/shared/metadataConstantsAndUtilities";
import {addDrawerNameToStack, removeDrawerNameToStack} from "../../../actions/drawerStackAction";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";


function QuestionnaireReviewHook(props) {
    const [openCategoryReview, setOpenCategoryReview] = useState(false);
    const [selectedCategoryInfoKey, setSelectedCategoryInfoKey] = useState("");
    const [selectedCategoryInfoId, setSelectedCategoryInfoId] = useState("");
    const [selectedCategoryInfoTemplate, setSelectedCategoryInfoTemplate] = useState({});

    const [openGroupReview, setOpenGroupReview] = useState(false);
    const [selectedGroupInfoKey, setSelectedGroupInfoKey] = useState("");
    const [selectedGroupInfoId, setSelectedGroupInfoId] = useState("");
    const [selectedGroupInfoTemplate, setSelectedGroupInfoTemplate] = useState({});

    const [openQuestionReview, setOpenQuestionReview] = useState(false);
    const [selectedQuestionInfoKey, setSelectedQuestionInfoKey] = useState("");
    const [selectedQuestionInfoId, setSelectedQuestionInfoId] = useState("");
    const [selectedQuestionInfoTemplate, setSelectedQuestionInfoTemplate] = useState("");

    const dispatch = useDispatch();
    
    // Redux state selectors
    // const template = useSelector(state =>
    //     state.questionnaireTemplate.hasOwnProperty(props.templateKey)
    //         ? state.questionnaireTemplate[props.templateKey]
    //         : null
    // );
    const questionnaireTemplateGraph = useSelector(state => state.questionnaireTemplateGraph);
    // const portalCount = useSelector(state => state.portal.portalCount);


    // ComponentWillMount equivalent
    useEffect(() => {
        dispatch(addDrawerNameToStack("Review", "Questionnaire"))
        // componentWillUnmount equivalent
        return () => {
            dispatch(expanderClear("QuestionnaireReview"));
            dispatch(clearQuestionnaireGraph());
            dispatch(removeDrawerNameToStack())
        };
    },[dispatch]);


    // Equivalent to componentDidMount
    useEffect(() => {

        if (props.templateId) {
            dispatch(getQuestionnaireGraph(props.templateId));
        }

    }, [dispatch, props.templateId]);

    const handleToolbarButtonClick = (event, fieldName, buttonTitle) => {
        if (buttonTitle === 'BACK') {
            setOpenCategoryReview(false);
            setOpenGroupReview(false);
            setOpenQuestionReview(false);
        }
    };

    const setStateCallback = (stateObj) => {

        if (stateObj.hasOwnProperty('openCategoryReview')) setOpenCategoryReview(stateObj.openCategoryReview);
        if (stateObj.hasOwnProperty('selectedCategoryInfoKey')) setSelectedCategoryInfoKey(stateObj.selectedCategoryInfoKey);
        if (stateObj.hasOwnProperty('selectedCategoryInfoId')) setSelectedCategoryInfoId(stateObj.selectedCategoryInfoId);
        if (stateObj.hasOwnProperty('selectedCategoryInfoTemplate')) setSelectedCategoryInfoTemplate(stateObj.selectedCategoryInfoTemplate);

        if (stateObj.hasOwnProperty('openGroupReview')) setOpenGroupReview(stateObj.openGroupReview);
        if (stateObj.hasOwnProperty('selectedGroupInfoKey')) setSelectedGroupInfoKey(stateObj.selectedGroupInfoKey);
        if (stateObj.hasOwnProperty('selectedGroupInfoId')) setSelectedGroupInfoId(stateObj.selectedGroupInfoId);
        if (stateObj.hasOwnProperty('selectedGroupInfoTemplate')) setSelectedGroupInfoTemplate(stateObj.selectedGroupInfoTemplate);

        if (stateObj.hasOwnProperty('openQuestionReview')) setOpenQuestionReview(stateObj.openQuestionReview);
        if (stateObj.hasOwnProperty('selectedQuestionInfoKey')) setSelectedQuestionInfoKey(stateObj.selectedQuestionInfoKey);
        if (stateObj.hasOwnProperty('selectedQuestionInfoId')) setSelectedQuestionInfoId(stateObj.selectedQuestionInfoId);
        if (stateObj.hasOwnProperty('selectedQuestionInfoTemplate')) setSelectedQuestionInfoTemplate(stateObj.selectedQuestionInfoTemplate);

    };

    if (openCategoryReview) {
        return <ArgoReviewTemplateHook
            templateType={TEMPLATE.TYPE.CATEGORY}
            templateKey={selectedCategoryInfoKey}
            templateId={selectedCategoryInfoId}
            selectedTemplate={selectedCategoryInfoTemplate}
            selectedTemplateIsGraph={true}
            handleToolbarButtonClickFunction={handleToolbarButtonClick}
            width={props.width}
        />;
    }

    if (openGroupReview) {
        return <ArgoReviewTemplateHook
            templateType={TEMPLATE.TYPE.GROUP}
            templateKey={selectedGroupInfoKey}
            templateId={selectedGroupInfoId}
            selectedTemplate={selectedGroupInfoTemplate}
            selectedTemplateIsGraph={true}
            handleToolbarButtonClickFunction={handleToolbarButtonClick}
            width={props.width}
        />;
    }

    if (openQuestionReview) {
        return <ArgoReviewTemplateHook
            templateType={TEMPLATE.TYPE.QUESTION}
            templateKey={selectedQuestionInfoKey}
            templateId={selectedQuestionInfoId}
            selectedTemplate={selectedQuestionInfoTemplate}
            selectedTemplateIsGraph={true}
            handleToolbarButtonClickFunction={handleToolbarButtonClick}
            width={props.width}
        />;
    }

    let questionnaireTemplateGraphClone = portalShared.cloneObj(questionnaireTemplateGraph);

    let current = true
    if (questionnaireTemplateGraph?.questionCategoryTemplates) {
        current = questionnaireTemplateGraph?.questionCategoryTemplates.every(category =>
            category.currentFlag !== false &&
            category.groupTemplates.every(group =>
                group.currentFlag !== false &&
                group.questionTemplates.every(question =>
                    question.currentFlag !== false
                )
            )
        );
    }

    return (
        (questionnaireTemplateGraphClone?.id) ?
            <div id="QuestionnaireReview-container-div" style={{ flexGrow: "2", padding: "32px" }}>
                <div style={{minHeight: "min-content"}}>

                    <Typography variant="h6" component="div">
                        Questionnaire Information:
                    </Typography>

                    <div>&nbsp;</div>

                    <div id="QuestionnaireReview-complex-question-type-container-div" style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        overflowWrap: "break-word"
                    }}>
                        <div style={{color: portalShared.LABEL_COLOR}}>Status:</div>
                        <div>&nbsp;</div>
                        <div>{statusFormatter(questionnaireTemplateGraphClone, 0, 0, true, true)}</div>
                        <div style={{
                            color: "red",
                            fontSize: "12px",
                            paddingTop: "2px"
                        }}>{questionnaireTemplateGraphClone.currentFlag ? "" : "(Not Current Version)"}</div>
                    </div>

                    <div>&nbsp;</div>

                    {!current ?
                        <React.Fragment>
                            <div style={{display: "flex"}}>
                                <FlagCircleIcon style={{color: "#E84343"}}/>
                                <div>&nbsp;</div>
                                <div style={{color: portalShared.colorNameToHex('red')}}>Not all components are current. To update components, republish questionnaire</div>
                            </div>

                            <div>&nbsp;</div>
                        </React.Fragment> : ""
                    }

                    <div id="QuestionnaireReview-complex-question-name-container-div" style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        overflowWrap: "break-word"
                    }}>
                        <div style={{color: portalShared.LABEL_COLOR}}>Questionnaire:</div>
                        <div>&nbsp;</div>
                        <div>{questionnaireTemplateGraphClone.name}</div>
                    </div>

                    <div>&nbsp;</div>

                    <div id="QuestionnaireReview-complex-question-qualifier-container-div" style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "flex-start",
                        alignItems: "center",
                        overflowWrap: "break-word"
                    }}>
                        <div style={{color: portalShared.LABEL_COLOR}}>Qualifier:</div>
                        <div>&nbsp;</div>
                        <div>{questionnaireTemplateGraphClone.nameQualifier}</div>
                    </div>

                    <div>&nbsp;</div>

                    <div style={{display: "flex"}}>
                        <div style={{color: portalShared.LABEL_COLOR}}>Questionnaire Classification:</div>
                        <div>&nbsp;</div>
                        <div>{!questionnaireTemplateGraphClone.metadata.hasOwnProperty(portalShared.KEY_METRIC_CATEGORY_QUESTIONNAIRE) ? 'None' : questionnaireTemplateGraphClone.metadata[portalShared.KEY_METRIC_CATEGORY_QUESTIONNAIRE]}</div>
                    </div>

                    <div>&nbsp;</div>

                    <div>
                        {metadataUtils.listMetadata(questionnaireTemplateGraphClone, "Questionnaire")}
                    </div>
                </div>

                {/*// ===========================================================================================================*/}
                {/*// ASSIGNED CATEGORIES LIST */}
                {/*// ===========================================================================================================*/}

                <CategoryViewerExpandableHook
                    parentName="QuestionnaireReview"
                    showIconButtonReorder={false}
                    showIconButtonEdit={false}
                    showIconButtonRemove={false}
                    hidePortalPreview={true}
                    setStateCallback={setStateCallback}
                    useGraph={true}
                    questionnaireGraph={questionnaireTemplateGraphClone}
                />

                <div id="QuestionnaireReview-space-1" style={{ height: "20px" }}>&nbsp;</div>

                {/*// ===========================================================================================================*/}
                {/*// PORTAL PREVIEW DIVIDER */}
                {/*// ===========================================================================================================*/}

                <ArgoDividerWithLabelHook
                    fileName="QuestionnaireReview"
                    label="Portal Preview"
                />

                {/*// ===========================================================================================================*/}
                {/*// QUESTIONNAIRE PORTAL PREVIEW */}
                {/*// ===========================================================================================================*/}

                <div id="QuestionnaireReview-space-2" style={{ height: "10px" }}>&nbsp;</div>

                <div id="QuestionnaireReview-div">
                    <ArgoPortalPreviewHook
                        calledBy="QuestionnaireReview"
                        templateType={TEMPLATE.TYPE.QUESTIONNAIRE_GRAPH}
                        template={questionnaireTemplateGraphClone}
                        templateGraph={questionnaireTemplateGraphClone}
                    />
                </div>

            </div>
            : ""
    );
}

QuestionnaireReviewHook.defaultProps = {
    templateId: null,
    width: "100%"
};

QuestionnaireReviewHook.propTypes = {
    templateId: PropTypes.number,
    width: PropTypes.string
};

export default QuestionnaireReviewHook;